// extracted by mini-css-extract-plugin
module.exports = {"errorText":"ErrorText_errorText__3pSCa","fadeIn":"ErrorText_fadeIn__1NHbk","fadeOut":"ErrorText_fadeOut__S5yfG"};